<template>
  <div class="resource-container">
    <resource-info />
    <div class="tab-action">
      <div class="tab-action_sub">
        <div
          class="tab-update tab-normal"
          :class="{ 'tab-active': tab === 1 }"
          @click="tab = 1"
        >
          {{ $t("resource.tab.effort") }}
        </div>
      </div>
      <div class="tab-action_sub">
        <div
          class="tab-effort tab-normal"
          :class="{ 'tab-active': tab === 2 }"
          @click="tab = 2"
        >
          {{ $t("resource.tab.history") }}
        </div>
      </div>
    </div>
    <div class="hr">
      <hr>
    </div>
    <div class="tabs-ctn">
      <ResourceEffort v-if="tab === 1"></ResourceEffort>
      <ProjectsHistory v-if="tab === 2"></ProjectsHistory>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResourceInfo from "./ResourceInfo";
import ResourceEffort from "./ResourceEffort";
import ProjectsHistory from "./ProjectsHistory";

export default {
  name: "ResourceDetailLayout",
  components: {
    ResourceInfo,
    ResourceEffort,
    ProjectsHistory,
  },
  metaInfo() {
    return {
      title: this.$t("bread_crumb.resource.info"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      tab: 1,
    };
  },
  computed: {
    ...mapGetters({}),
  },
  created() {
    // if (!this.project.id) {
    //   this.$store.dispatch("project/showDetail", this.$route.params.id)
    // }
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "Helvetica Neue";
  src: url('../../../assets/font/helveticaneuemedium.ttf') format("truetype");
}

@font-face {
  font-family: "Roboto";
  src: url('../../../assets/font/Roboto-Medium.ttf') format("truetype");
}
.resource-container {
  margin: -20px -30px 30px -30px;
  .tab-action {
    display: flex;
    background: #ffffff;
    //border-radius: 10px 10px 0 0;
    margin-top: 12px;
    &_sub {
      font-family: "Roboto";
      font-weight: 500;
      font-size: 18px;
      line-height: 69px;
      color: #303c54;
      padding: 0 20px 0 30px;
      cursor: pointer;
      .tab-normal {
        color: #A5A5A5;
      }
    }
  }
  .hr{
    background: #ffffff;
    hr {
      border-top: 1px solid #cfcfcf;
      margin: 0 0 0 30px;
      height: 1px;
    }
  }
  .tab-active {
    color: #303C54!important;
    border-bottom: 4px solid #3488eb;
  }
  .tabs-ctn {
    padding: 0 30px;
    background: #ffffff;
  }
}
</style>
